<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-24 09:16:24
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-10-15 11:38:20
 * @Description: 补贴项目发放明细（按项目+发放批次）
 * @FilePath: \gfmis-card-ppt\src\views\subsidize\issueDetailBatch.vue
-->
<template>
  <div class="pageRoot" :class="tableData.length > 5 ? 'pageRootNew' : ''">
    <head-com class="head-com" :headObj="headObj"></head-com>
    <tree-table-com class="content" v-loading="loading" v-bind="tableConfig" :tablePageConfig="pageConfig"
      :tableData="tableData" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      @searchChange="searchChange">
      <!-- <template #tableHeadAfter>
        <div class="table-head-up">
          <div>发放单位: <span class="table-head-up-value">{{ tableHeadObj.agencyName }}</span></div>
          <div>发放采集单号: <span class="table-head-up-value">{{ tableHeadObj.pcNo }}</span></div>
          <div>发放时间: <span class="table-head-up-value">{{ tableHeadObj.payDate }}</span></div>
        </div>
      </template> -->
    </tree-table-com>
  </div>
</template>
<script>
import headCom from '@/components/headCom.vue';
import treeTableCom from '@/components/treeTableCom.vue'
import commonJs from '@/views/mixins/common'
import Api from '@/api/cardProject'
import XEUtils from 'xe-utils';

export default {
  mixins: [commonJs],
  data() {
    return {
      Api: { getList: Api.getCardReqInfoDetail },
      headObj: {
        cnTitleName: '发放信息公示',
        enTitleName: 'SUBSIDIES'
      },
      tableHeadObj: {
        agencyName: '',
        pcNo: '',
        payDate: '',
      },
      tableConfig: {
        isShowSummary: true,
        titleTvArray: [],
        getSummaries: this.getSummaries,
        tableColumn: [
          {
            field: 'pername',
            title: '补贴范围(对象)',
            width: 100,
          },
          {
            field: 'identityid',
            title: '证件号码',
            width: 180
          }, {
            field: 'admDivName',
            title: '行政区划(采集区划)',
            width: 250
          },
          {
            field: 'admDivLastName',
            title: '村委会(村小组)',
            width: 250
          },
          {
            field: 'realAmt',
            title: '发放金额(元)',
            align: 'right',
            fdatatype: 'C',
            width: 120
          },
          {
            field: 'soaccTypeName',
            title: '收款账户类别',
            width: 120
          },
          {
            field: 'account',
            title: '收款账号',
            width: 180
          },
          {
            field: 'agencyName',
            title: '发放单位',
            width: 200
          },
          {
            field: 'pcNo',
            title: '发放采集单号',
            width: 200
          },
          {
            field: 'payDate',
            title: '发放时间',
            width: 180
          },
        ]
      },
    }
  },
  components: { headCom, treeTableCom },
  mounted() {
    this.$nextTick(() => {
      this.mofDivName = this.$store.getters.getCurrentNode
      this.parentComParams = this.$route.params
      this.tableConfig.titleTvArray = [...this.getTitleArr, '发放明细']
    })
    this.getList();
  },
  methods: {
    getListBefore({ currentPage = this.pageConfig.currentPage, pageSize = this.pageConfig.pageSize }) {
      this.tableData = []
      const params = this.$route.query || {};
      return {
        method: this.Api.getList,
        args: {
          currentPage,
          pageSize,
          model: {
            ...params,
            agencyName: this.searchParam
          }
        },
      };
    },
    getListAfter() {
      const params = this.$route.query || {};
      this.tableData?.forEach((v, index) => {
        if (index === 0) {
          let payDate = ''
          if (params.payDate) {
            payDate = params.payDate.split(' ')[0]
          }
          this.tableHeadObj = {
            agencyName: v.agencyName,
            pcNo: v.pcNo,
            payDate: payDate || '',
          }
        }
        v.realAmt = XEUtils.commafy(v.realAmt, { digits: 2 }) || ''
      })
    },
    getSummaries(param) {
      const { data } = param;
      const sums = [];
      this.tableConfig.tableColumn?.forEach((column, index) => {
        const colIndex = index + 1;
        if (column.field === 'identityid') {
          sums[colIndex] = <div style="textAlign: right" >合计:</div>;
          return;
        }
        const values = data.map(item => XEUtils.toNumber(item[column.field]));
        if (['N', 'C'].includes(column.fdatatype) && !values.every(value => isNaN(value))) {
          sums[colIndex] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Number(prev) + Number(curr);
            } else {
              return Number(prev);
            }
          }, 0);
          if (column.fdatatype == 'C') {
            const realAmt = XEUtils.commafy(sums[colIndex], { digits: 2 })
            sums[colIndex] = realAmt;
          }
        }
      });
      return sums;
    },
  }
}
</script>
<style lang="scss" scoped>
.pageRootNew {
  height: initial;
  min-height: 100%;
  height: calc(100% + 140px);
}

.content {
  margin: 0 100px;
  background-color: white;

  .table-head-up {
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    color: #666666;

    div {
      min-width: 150px;
    }

    &-value {
      color: black;
    }
  }
}
</style>
